<app-loading-overlay [isLoading]="!!isLoading"></app-loading-overlay>
<div class="page-container">
  <div class="page-header">
    <div class="help-link">
      <span class="help-text">Have any questions?</span>

      <span class="contact">
        <span nz-icon nzType="customer-service" nzTheme="outline"></span>
        <a nz-button nzType="link" class="contact-link" (click)="contactUs()">Request Assistance</a>
      </span>
    </div>
  </div>
  <nz-tabset (nzSelectedIndexChange)="onTabChange($event)">
    <nz-tab nzTitle="Resources">
      <nz-table #basicTable [nzData]="manuals" nzBordered nzSize="middle">
        <tbody>
          <tr *ngFor="let item of basicTable.data">
            <td>
              <div class="btn">
                <span nz-icon nzType="file-text" nzTheme="outline"></span>
                <span> {{ item.title }} ( {{ item.description }} )</span>
                <button class="download" nz-button nzType="primary" (click)="downloadResource(item.fileUrl)">
                  <span nz-icon nzType="download"></span>
                  Download
                </button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="btn">
                <span class="support-text">
                  <span class="support-title">
                    <span class="support-icon" nz-icon nzType="customer-service" nzTheme="outline"></span>
                    <span>International League Managed Service Model Support Desk</span>
                  </span>
                  <p>
                    Use the International Club Service Desk to request support, ask questions, or report issues related
                    to the portal, activations, campaigns, and other activities supported through the International
                    League Managed Model.
                  </p>
                </span>
                <button
                  class="download"
                  nz-button
                  nzType="primary"
                  nz-tooltip
                  nzTooltipTitle="Click here for questions and support related to the International League Managed Model"
                  (click)="contactUs()"
                >
                  <span nz-icon nzType="customer-service"></span>
                  Service Desk
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </nz-tab>
    <!--
    <nz-tab nzTitle="Reports">
      <div class="reports-wrapper">
        <nz-collapse class="custom-collapse" nzBordered="false">
          <nz-collapse-panel
            *ngFor="let group of reports"
            [nzHeader]="group.groupName + ' (' + group.reports.length + ' reports)'"
            [(nzActive)]="group.active"
            [nzShowArrow]="false"
            [nzExtra]="extraTpl"
          >
            <div class="report-row" *ngFor="let report of group.reports">
              <div class="report-info">
                <span nz-icon nzType="file-text"></span>
                <span class="report-name">
                  {{ report.name }}
                  <span class="file-size">({{ report.size }})</span>
                </span>
              </div>
              <button class="download" nz-button nzType="primary" (click)="downloadResource(report.fileUrl)">
                <span nz-icon nzType="download"></span>
                Download File
              </button>
            </div>
            <ng-template #extraTpl>
              <span class="custom-arrow" [class.active]="group.active"></span>
            </ng-template>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
    </nz-tab>
    -->

    <!--
    <nz-tab nzTitle="FAQs">
      <div class="faqs-wrapper">
        <nz-collapse class="custom-collapse" nzBordered="false">
          <nz-collapse-panel
            *ngFor="let item of faqs"
            [nzHeader]="item.question"
            [(nzActive)]="item.active"
            [nzShowArrow]="false"
            [nzExtra]="extraTpl"
          >
            <ng-template #extraTpl>
              <span class="custom-arrow" [class.active]="item.active"></span>
            </ng-template>
            <div class="answer">
              {{ item.answer }}
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
    </nz-tab>
    -->
  </nz-tabset>
</div>
